import * as action from '../store/action-types'

function overlayOptionProp (key, options) {
  options = Object.assign({}, options)
  return {
    get: function () {
      const value = this.$store.getters.overlayOptions(this.templateId)[key]
      return (value === null || value === undefined) ? options.default : value
    },
    set: function (val) {
      this.$store.dispatch(action.TEMPLATE_OVERLAY_OPTIONS, {
        templateId: this.templateId,
        options: {[key]: val}
      })
    }
  }
}

export default overlayOptionProp



// WEBPACK FOOTER //
// ./src/utils/overlayOptionProp.js